import React, { useCallback } from 'react';
import { Layout, Button } from 'antd';
import { connect } from 'react-redux';
import { Redirect, Route, useHistory, useLocation, withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
	contractorClientsRestCrudThunksForBuyer,
	contractorClientsRestCrudThunksForSupplier,
} from '../../thunks/contractor_clients_thunks';
import { updateNavbarState } from '../../actions/navbar_actions';
import SubnavTabs from '../subnav_tabs/SubnavTabs';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import queryString from 'qs';
import { generateBackLink } from '../../utils/HistoryUtils';
import { ConnectedTag, SelfManagedTag } from './ContractorClientsIndexPage';
const { Content } = Layout;

const ContractorClientDetailDetailsPage = ({
	fetchContractorClient,
	contractorClient,
	companyConfig,
	childRoutes,
	userType,

	match,
	updateNavbar,
}) => {
	const id = match.params.id;

	const [loading, setLoading] = useState(false);

	const history = useHistory();
	const location = useLocation();

	useEffect(() => {
		setLoading(true);
		fetchContractorClient(id).then(() => setLoading(false));

		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);

		if (queryParams.targetCollectionName) {
			this.setState({ fromTargetCollectionName: queryParams.targetCollectionName });
		}
		if (queryParams.backlinkParams) {
			const { pathName, backLinkText } = queryString.parse(queryParams.backlinkParams);
			let backPath = pathName || `/${userType}/contractor_clients/overview/all`;
			let backText = backLinkText || 'Back to Clients';
			updateNavbar(backText, generateBackLink(backPath, location));
		} else {
			updateNavbar(
				'Back to Clients',
				generateBackLink(`/${userType}/contractor_clients/overview/all`, location)
			);
		}
	}, []);

	const handleTabChange = useCallback(
		(key) => {
			history.push(`/${userType}/contractor_clients/detail/${id}/${key}`);
		},
		[history, id, userType]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(`/${key}`) !== -1;
		},
		[history.location.pathname]
	);

	const tabs = React.useMemo(() => {
		return [
			{
				key: 'details',
				name: 'Overview',
			},
			{
				key: 'locations',
				name: 'Locations',
			},
		];
	}, []);

	return (
		<div>
			<Route
				path={`/${userType}/contractor_clients/detail/:id`}
				exact
				render={() => <Redirect to={`/${userType}/contractor_clients/detail/${id}/details`} />}
			/>
			<Content className="projectTemplateDetailPage" style={{ padding: '0 0.5em' }}>
				<div
					style={{
						margin: '0 -8px',
						padding: '24px',
						paddingBottom: 0,
						background: nullSafeGet('detail.config.theme.navblock', companyConfig),
						marginBottom: 8,
					}}
				>
					<h4
						style={{
							fontSize: 32,
							minHeight: 41,
							color: 'rgba(255, 255, 255, 0.9)',
							marginRight: 8,
							marginBottom: 24,
						}}
					>
						<div>
							{nullSafeGet('name', contractorClient)}
							<div className="">
								{nullSafeGet('clientBuyerCompany', contractorClient) ||
								nullSafeGet('clientSupplierFacility', contractorClient)
									? ConnectedTag
									: SelfManagedTag}
							</div>
						</div>
					</h4>
					<SubnavTabs tabs={tabs} onChange={handleTabChange} isActive={checkTabActive} />
					<div style={{ position: 'absolute', top: 60, right: 40 }}>
						<Link to={`/${userType}/contractor_clients/edit/${id}`} style={{ marginRight: 16 }}>
							<Button ghost>Edit</Button>
						</Link>
					</div>
				</div>
				{childRoutes.map((r, i) => (
					<RouteWithSubRoutes key={i} {...r} />
				))}
			</Content>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => ({
	companyConfig: state.company_config,
	match: ownProps.match,
	history: ownProps.history,
	currentUser: state.session.currentUser,
	contractorClient: state.contractor_clients.detail,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	fetchContractorClient: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? contractorClientsRestCrudThunksForSupplier.readOne(id)
				: contractorClientsRestCrudThunksForBuyer.readOne(id)
		),
	updateNavbar: (backlinkTitle, backlinkTo, navbarBackgroundColor) =>
		dispatch(updateNavbarState(backlinkTitle, backlinkTo, navbarBackgroundColor)),
});

const ComponentWithoutUserType = withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(ContractorClientDetailDetailsPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
